import { render, staticRenderFns } from "./data-set-editor-dialog.vue?vue&type=template&id=38af55da&"
import script from "./data-set-editor-dialog.vue?vue&type=script&lang=js&"
export * from "./data-set-editor-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports